import React from "react";
import Map from "../Map/Map";

function FindBank() {
  return (
    <div className="w-full bg-white ">
      <img
        src="/coat-drive.png"
        alt="logo"
        className="w-full h-full max-h-[calc(100vh-80px)] object-contain"
      />
      <div className="w-full max-w-[1300px] m-auto flex justify-center items-center flex-col md:px-6 px-4">
        <h1 className="font-noto font-semibold text-5xl mt-12 text-main text-center">
          Find bank near you
        </h1>
        {/* Marker */}
        <div className="w-full md:h-[80vh] h-[300px] overflow-hidden rounded-lg drop-shadow-lg my-6">
          <Map />
        </div>
      </div>
    </div>
  );
}

export default FindBank;
